import { render, staticRenderFns } from "./Messagerie.vue?vue&type=template&id=78d6f802&scoped=true"
import script from "./Messagerie.vue?vue&type=script&lang=js"
export * from "./Messagerie.vue?vue&type=script&lang=js"
import style0 from "./Messagerie.vue?vue&type=style&index=0&id=78d6f802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d6f802",
  null
  
)

export default component.exports